import { JsonObject, JsonProperty } from 'json2typescript';

import { Client } from './client.enum';
import { MediaInfo } from '../media/media-info';

@JsonObject
export class TenantPicture {
  /**
   * å»é¢èªå®ä¹å¾çId
   */
  @JsonProperty('id', Number)
  id: Number = undefined;

  /**
   * å»é¢èªå®ä¹å¾ççåºå·
   */
  @JsonProperty('idx', Number)
  idx: Number = undefined;

  /**
   * å¾ççåªä½èµæºä¿¡æ¯
   */
  @JsonProperty('medioInfo', MediaInfo)
  mediaInfo: MediaInfo = undefined;

  /**
   * å¾çéç¨çå¹³å°(PC, WX)
   */
  @JsonProperty('client', Client)
  client: Client = undefined;
}
